import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=07b190a4&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=07b190a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b190a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07b190a4')) {
      api.createRecord('07b190a4', component.options)
    } else {
      api.reload('07b190a4', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=07b190a4&scoped=true&", function () {
      api.rerender('07b190a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VYNnpf7hkKW1/JS/comp/PopupBox.vue"
export default component.exports